// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { RecurringSessionSelectRecurringCadenceFragmentDoc } from './RecurringSessionSelect.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ScheduleModalSidebarCoachFragment = {
  __typename?: 'Coach';
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  user: { __typename?: 'User'; firstName: string; lastName: string };
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
  } | null;
};

export type ScheduleModalSidebarCoachingSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  durationInMinute: number;
  recurringSession?: { __typename?: 'RecurringSession'; id: string } | null;
  content:
    | { __typename: 'BootcampSession' }
    | { __typename: 'Class' }
    | { __typename: 'EventSession' }
    | {
        __typename: 'OneOnOneSession';
        introOrder?: {
          __typename?: 'Order';
          introCall?: {
            __typename?: 'IntroCall';
            packages?: Array<{
              __typename?: 'OfferingPackage';
              id: string;
            }> | null;
          } | null;
        } | null;
      };
};

export type ScheduleModalSidebarRecurringCadenceFragment = {
  __typename?: 'RecurringCadence';
  type: Types.RecurrenceType;
  startHour: number;
  startMinute: number;
  durationMinutes: number;
  dayOfWeek?: Types.DayOfWeek | null;
  weekOfMonth?: number | null;
  interval?: number | null;
  isLastWeekOfMonth?: boolean | null;
};

export type ScheduleModalSidebarOrderFragment = {
  __typename?: 'Order';
  id: string;
  finalAmount?: number | null;
  hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
};

export type ScheduleModalSidebarUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ScheduleModalSidebarUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    applicant?: {
      __typename?: 'Applicant';
      id: string;
      blockIntroUntil?: number | null;
      hasUnassignedTrialOrder?: boolean | null;
      introSummary?: {
        __typename?: 'IntroSummary';
        hasIntroQuota: boolean;
        numOfDailyIntroRemaining: number;
        numOfBetweenPurchaseIntroRemaining: number;
      } | null;
    } | null;
  } | null;
};

export const ScheduleModalSidebarCoachFragmentDoc = gql`
  fragment ScheduleModalSidebar_Coach on Coach {
    user {
      firstName
      lastName
    }
    couldScheduleIntro
    everHadCoachingSessionWithCoach
    coachingRelationship {
      id
      customerSubscription {
        id
        sku {
          id
          family
        }
      }
    }
    hourlyRate
    coachingTimeSummary {
      availableTime
    }
    tier
  }
`;
export const ScheduleModalSidebarCoachingSessionFragmentDoc = gql`
  fragment ScheduleModalSidebar_CoachingSession on CoachingSession {
    id
    durationInMinute
    recurringSession {
      id
    }
    content {
      __typename
      ... on OneOnOneSession {
        introOrder {
          introCall {
            packages {
              id
            }
          }
        }
      }
    }
  }
`;
export const ScheduleModalSidebarRecurringCadenceFragmentDoc = gql`
  fragment ScheduleModalSidebar_RecurringCadence on RecurringCadence {
    ...RecurringSessionSelect_RecurringCadence
  }
  ${RecurringSessionSelectRecurringCadenceFragmentDoc}
`;
export const ScheduleModalSidebarOrderFragmentDoc = gql`
  fragment ScheduleModalSidebar_Order on Order {
    id
    hourlyOrder {
      timeInMinute
    }
    finalAmount
  }
`;
export const ScheduleModalSidebarUserDocument = gql`
  query ScheduleModalSidebar_User {
    user {
      id
      applicant {
        id
        blockIntroUntil
        hasUnassignedTrialOrder
        introSummary {
          hasIntroQuota
          numOfDailyIntroRemaining
          numOfBetweenPurchaseIntroRemaining
        }
      }
    }
  }
`;

/**
 * __useScheduleModalSidebarUserQuery__
 *
 * To run a query within a React component, call `useScheduleModalSidebarUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleModalSidebarUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleModalSidebarUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduleModalSidebarUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ScheduleModalSidebarUserQuery,
    ScheduleModalSidebarUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduleModalSidebarUserQuery,
    ScheduleModalSidebarUserQueryVariables
  >(ScheduleModalSidebarUserDocument, options);
}
export function useScheduleModalSidebarUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduleModalSidebarUserQuery,
    ScheduleModalSidebarUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduleModalSidebarUserQuery,
    ScheduleModalSidebarUserQueryVariables
  >(ScheduleModalSidebarUserDocument, options);
}
export function useScheduleModalSidebarUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScheduleModalSidebarUserQuery,
        ScheduleModalSidebarUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduleModalSidebarUserQuery,
    ScheduleModalSidebarUserQueryVariables
  >(ScheduleModalSidebarUserDocument, options);
}
export type ScheduleModalSidebarUserQueryHookResult = ReturnType<
  typeof useScheduleModalSidebarUserQuery
>;
export type ScheduleModalSidebarUserLazyQueryHookResult = ReturnType<
  typeof useScheduleModalSidebarUserLazyQuery
>;
export type ScheduleModalSidebarUserSuspenseQueryHookResult = ReturnType<
  typeof useScheduleModalSidebarUserSuspenseQuery
>;
export type ScheduleModalSidebarUserQueryResult = Apollo.QueryResult<
  ScheduleModalSidebarUserQuery,
  ScheduleModalSidebarUserQueryVariables
>;
